export default {
  enable() {
    !(function (win, doc, scriptTag, scriptUrl) {
      if (win.fbq) return;
      const n = (win.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      });
      if (!win._fbq) win._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      const t = doc.createElement(scriptTag);
      t.async = !0;
      t.src = scriptUrl;
      const s = doc.getElementsByTagName(scriptTag)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
  },
  wait() {
    return !!window.fbq;
  },
  init() {
    window.fbq("init", "1649877658563488");
  },
  paso1() {
    window.fbq("track", "ViewContent", {
      content_type: "Referidos openmarket"
    });
  },
  paso2() {
    window.fbq("track", "AddToCart", {
      content_type: "Referidos openmarket"
    });
  },
  paso3() {
    window.fbq("track", "Purchase", {
      content_type: "Referidos openmarket"
    });
  }
};
